// extracted by mini-css-extract-plugin
module.exports = {"tags":"tag-list_tags_31R07","tag":"tag-list_tag_14znY"};